import React from "react";
import { Link } from "react-router-dom";
import "./App.css";
import AppFooter from "./AppFooter";

function Contact() {
  const homePath = "/";

  return (
    <div className="app-container contact-page">
      <header className="app-header">
        <div className="header-content">
          <Link to={homePath} className="simple-brand-link">
            <span className="simple-brand-mark" aria-hidden="true">S</span>
            <span className="simple-brand-text">StatementIQ</span>
          </Link>
        </div>
      </header>

      <main className="main-content">
        <div className="panel" style={{ maxWidth: 760 }}>
          <h2>Contact Us</h2>
          <p style={{ lineHeight: 1.7 }}>
            If you need help with statement conversion, file errors, or account access,
            please contact our support team.
          </p>

          <p style={{ marginTop: 20, lineHeight: 1.7 }}>
            Include your name, email, and a short description of the issue so we can
            investigate quickly.
          </p>

          <p style={{ marginTop: 24, fontWeight: 700, marginBottom: 6 }}>
            Email Support
          </p>
          <p style={{ marginTop: 0 }}>
            <a
              href="mailto:support@statementiq.co.uk"
              style={{ color: "#0A58C0", textDecoration: "none" }}
            >
              support@statementiq.co.uk
            </a>
          </p>

        </div>
      </main>

      <AppFooter />
    </div>
  );
}

export default Contact;
